export function exportCSV(results, asin) {
  const header = 'Keyword,Rank,Page,Volume,Sponsored\n';
  const rows = results.map(r =>
    `"${r.keyword}",${r.rank},${r.page},"${r.volume || 'Unknown'}",${r.sponsored ? 'Yes' : 'No'}`
  ).join('\n');

  const blob = new Blob([header + rows], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = `keywords-${asin}-${new Date().toISOString().slice(0, 10)}.csv`;
  link.click();
  URL.revokeObjectURL(url);
}

export function volumeClass(vol) {
  if (!vol) return 'vol-low';
  const v = vol.toLowerCase();
  if (v.includes('high')) return 'vol-high';
  if (v.includes('medium') || v.includes('mid')) return 'vol-medium';
  return 'vol-low';
}

export function rankClass(rank) {
  if (rank <= 5) return 'rank-top';
  if (rank <= 20) return 'rank-good';
  return 'rank-ok';
}

export function isValidASIN(str) {
  return /^[A-Z0-9]{10}$/i.test(str.trim());
}
